module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    var child0 = (function() {
      var child0 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            inline(env, morph0, context, "t", ["promos.edit.menu.main"], {});
            return fragment;
          }
        };
      }());
      var child1 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            inline(env, morph0, context, "t", ["promos.edit.menu.conditions"], {});
            return fragment;
          }
        };
      }());
      var child2 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            inline(env, morph0, context, "t", ["promos.edit.menu.bonuses"], {});
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, block = hooks.block;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
          var morph2 = dom.createMorphAt(fragment,2,2,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          block(env, morph0, context, "sm-segment", [], {"option": "main"}, child0, null);
          block(env, morph1, context, "sm-segment", [], {"option": "conditions"}, child1, null);
          block(env, morph2, context, "sm-segment", [], {"option": "bonuses"}, child2, null);
          return fragment;
        }
      };
    }());
    var child1 = (function() {
      var child0 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child1 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child2 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child3 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("span");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.timetable.enabled"], {});
            return fragment;
          }
        };
      }());
      var child4 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("span");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.timetable.disabled"], {});
            return fragment;
          }
        };
      }());
      var child5 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            inline(env, morph0, context, "timetable-editor", [], {"classNames": "promo-timetable", "timetables": get(env, context, "promo.timetables")});
            return fragment;
          }
        };
      }());
      var child6 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child7 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control once-only");
            var el3 = dom.createElement("div");
            dom.setAttribute(el3,"class","caption warning");
            var el4 = dom.createComment("");
            dom.appendChild(el3, el4);
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0, 1, 0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.not_delivery_takeaway_warning"], {});
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createTextNode(" ");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","actual-range");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          var el5 = dom.createElement("span");
          dom.setAttribute(el5,"class","separator");
          var el6 = dom.createComment("");
          dom.appendChild(el5, el6);
          dom.appendChild(el4, el5);
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","custom-timetable");
          var el5 = dom.createElement("div");
          var el6 = dom.createComment("");
          dom.appendChild(el5, el6);
          dom.appendChild(el4, el5);
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","priority");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block, element = hooks.element;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var element96 = dom.childAt(fragment, [0]);
          var element97 = dom.childAt(element96, [0]);
          var element98 = dom.childAt(element96, [1]);
          var element99 = dom.childAt(element96, [2]);
          var element100 = dom.childAt(element96, [3]);
          var element101 = dom.childAt(element100, [1]);
          var element102 = dom.childAt(fragment, [1, 0]);
          var element103 = dom.childAt(element102, [1]);
          var element104 = dom.childAt(element103, [0]);
          var element105 = dom.childAt(element103, [1]);
          var element106 = dom.childAt(element105, [0]);
          var element107 = dom.childAt(fragment, [2]);
          var element108 = dom.childAt(element107, [0]);
          var element109 = dom.childAt(element108, [1]);
          var element110 = dom.childAt(element107, [1]);
          var element111 = dom.childAt(element107, [2]);
          var element112 = dom.childAt(element107, [3]);
          var element113 = dom.childAt(element107, [4]);
          var element114 = dom.childAt(element107, [5]);
          var morph0 = dom.createMorphAt(dom.childAt(element97, [0]),0,0);
          var morph1 = dom.createMorphAt(dom.childAt(element97, [1]),0,0);
          var morph2 = dom.createMorphAt(dom.childAt(element98, [0]),0,0);
          var morph3 = dom.createMorphAt(dom.childAt(element98, [1]),0,0);
          var morph4 = dom.createMorphAt(dom.childAt(element99, [0]),0,0);
          var morph5 = dom.createMorphAt(dom.childAt(element99, [1]),0,0);
          var morph6 = dom.createMorphAt(dom.childAt(element100, [0]),0,0);
          var morph7 = dom.createMorphAt(element101,0,0);
          var morph8 = dom.createMorphAt(dom.childAt(element101, [1]),0,0);
          var morph9 = dom.createMorphAt(dom.childAt(element102, [0]),1,1);
          var morph10 = dom.createMorphAt(element104,0,0);
          var morph11 = dom.createMorphAt(dom.childAt(element104, [1]),0,0);
          var morph12 = dom.createMorphAt(element104,2,2);
          var morph13 = dom.createMorphAt(element106,0,0);
          var morph14 = dom.createMorphAt(element105,1,1);
          var morph15 = dom.createMorphAt(dom.childAt(element108, [0]),0,0);
          var morph16 = dom.createMorphAt(dom.childAt(element109, [0]),0,0);
          var morph17 = dom.createMorphAt(dom.childAt(element109, [1]),0,0);
          var morph18 = dom.createMorphAt(dom.childAt(element110, [0]),0,0);
          var morph19 = dom.createMorphAt(dom.childAt(element110, [1]),0,0);
          var morph20 = dom.createMorphAt(dom.childAt(element111, [0]),0,0);
          var morph21 = dom.createMorphAt(dom.childAt(element111, [1]),0,0);
          var morph22 = dom.createMorphAt(dom.childAt(element112, [0]),0,0);
          var morph23 = dom.createMorphAt(dom.childAt(element112, [1]),0,0);
          var morph24 = dom.createMorphAt(dom.childAt(element113, [0]),0,0);
          var morph25 = dom.createMorphAt(dom.childAt(element113, [1]),0,0);
          var morph26 = dom.createMorphAt(dom.childAt(element114, [0]),0,0);
          var morph27 = dom.createMorphAt(dom.childAt(element114, [1]),0,0);
          var morph28 = dom.createMorphAt(element114,2,2);
          inline(env, morph0, context, "t", ["promos.edit.name.label"], {});
          block(env, morph1, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.name.placeholder", "value": get(env, context, "promo.name")}, child0, null);
          inline(env, morph2, context, "t", ["promos.edit.description.label"], {});
          block(env, morph3, context, "sm-text-area", [], {"classNames": "full-width", "placeholdeTranslationr": "promos.edit.description.placeholder", "value": get(env, context, "promo.description")}, child1, null);
          inline(env, morph4, context, "t", ["promos.edit.offer_description.label"], {});
          block(env, morph5, context, "sm-text-area", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.offer_description.placeholder", "value": get(env, context, "promo.offer_description")}, child2, null);
          inline(env, morph6, context, "t", ["promos.edit.is_working.label"], {});
          inline(env, morph7, context, "sm-toggle", [], {"checked": get(env, context, "promo.is_working")});
          inline(env, morph8, context, "t", ["promos.edit.is_working.caption"], {});
          inline(env, morph9, context, "t", ["promos.edit.period.label"], {});
          inline(env, morph10, context, "sm-datetime-picker", [], {"value": get(env, context, "promo.actual_from"), "clearButton": true});
          inline(env, morph11, context, "t", ["promos.edit.period.to"], {});
          inline(env, morph12, context, "sm-datetime-picker", [], {"value": get(env, context, "promo.actual_till"), "clearButton": true});
          element(env, element106, context, "action", ["toggleTimetableEnabled"], {"on": "click"});
          element(env, element106, context, "bind-attr", [], {"class": ":timetable-switch promo.timetable_enabled:active"});
          block(env, morph13, context, "if", [get(env, context, "promo.timetable_enabled")], {}, child3, child4);
          block(env, morph14, context, "if", [get(env, context, "promo.timetable_enabled")], {}, child5, null);
          inline(env, morph15, context, "t", ["promos.edit.priority.label"], {});
          block(env, morph16, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholderTranslation": "promos.edit.priority.placeholder", "value": get(env, context, "promo.priority")}, child6, null);
          inline(env, morph17, context, "t", ["promos.edit.priority.caption"], {});
          inline(env, morph18, context, "t", ["promos.edit.disable_bonus_getting"], {});
          inline(env, morph19, context, "sm-toggle", [], {"checked": get(env, context, "promo.disable_bonus_getting")});
          inline(env, morph20, context, "t", ["promos.edit.disable_bonus_usage"], {});
          inline(env, morph21, context, "sm-toggle", [], {"checked": get(env, context, "promo.disable_bonus_usage")});
          inline(env, morph22, context, "t", ["promos.edit.is_takeaway"], {});
          inline(env, morph23, context, "sm-toggle", [], {"checked": get(env, context, "promo.is_takeaway")});
          inline(env, morph24, context, "t", ["promos.edit.is_delivery"], {});
          inline(env, morph25, context, "sm-toggle", [], {"checked": get(env, context, "promo.is_delivery")});
          inline(env, morph26, context, "t", ["promos.edit.is_dine_in"], {});
          inline(env, morph27, context, "sm-toggle", [], {"checked": get(env, context, "promo.is_dine_in")});
          block(env, morph28, context, "unless", [get(env, context, "promo.deliveryTypeSelected")], {}, child7, null);
          return fragment;
        }
      };
    }());
    var child2 = (function() {
      var child0 = (function() {
        var child0 = (function() {
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              return fragment;
            }
          };
        }());
        var child1 = (function() {
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control");
            var el3 = dom.createElement("div");
            dom.setAttribute(el3,"class","days-for-birthday");
            var el4 = dom.createComment("");
            dom.appendChild(el3, el4);
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control");
            var el3 = dom.createElement("div");
            dom.setAttribute(el3,"class","days-for-birthday");
            var el4 = dom.createComment("");
            dom.appendChild(el3, el4);
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var element43 = dom.childAt(fragment, [0]);
            var element44 = dom.childAt(fragment, [1]);
            var morph0 = dom.createMorphAt(dom.childAt(element43, [0]),0,0);
            var morph1 = dom.createMorphAt(dom.childAt(element43, [1, 0]),0,0);
            var morph2 = dom.createMorphAt(dom.childAt(element44, [0]),0,0);
            var morph3 = dom.createMorphAt(dom.childAt(element44, [1, 0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.for_birthday.before_birthday"], {});
            block(env, morph1, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholderTranslation": "promos.edit.for_birthday.placeholder", "value": get(env, context, "promo.before_birthday")}, child0, null);
            inline(env, morph2, context, "t", ["promos.edit.for_birthday.after_birthday"], {});
            block(env, morph3, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholderTranslation": "promos.edit.for_birthday.placeholder", "value": get(env, context, "promo.after_birthday")}, child1, null);
            return fragment;
          }
        };
      }());
      var child1 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            var el3 = dom.createElement("div");
            dom.setAttribute(el3,"class","caption");
            var el4 = dom.createComment("");
            dom.appendChild(el3, el4);
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            var el3 = dom.createElement("div");
            dom.setAttribute(el3,"class","caption");
            var el4 = dom.createComment("");
            dom.appendChild(el3, el4);
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline, get = hooks.get;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var element39 = dom.childAt(fragment, [0]);
            var element40 = dom.childAt(element39, [1]);
            var element41 = dom.childAt(fragment, [1]);
            var element42 = dom.childAt(element41, [1]);
            var morph0 = dom.createMorphAt(dom.childAt(element39, [0]),0,0);
            var morph1 = dom.createMorphAt(element40,0,0);
            var morph2 = dom.createMorphAt(dom.childAt(element40, [1]),0,0);
            var morph3 = dom.createMorphAt(dom.childAt(element41, [0]),0,0);
            var morph4 = dom.createMorphAt(element42,0,0);
            var morph5 = dom.createMorphAt(dom.childAt(element42, [1]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.timetable_for_order_time.label"], {});
            inline(env, morph1, context, "sm-toggle", [], {"checked": get(env, context, "promo.timetable_for_order_time")});
            inline(env, morph2, context, "t", ["promos.edit.timetable_for_order_time.caption"], {});
            inline(env, morph3, context, "t", ["promos.edit.timetable_for_asap_only.label"], {});
            inline(env, morph4, context, "sm-toggle", [], {"checked": get(env, context, "promo.timetable_for_asap_only")});
            inline(env, morph5, context, "t", ["promos.edit.timetable_for_asap_only.caption"], {});
            return fragment;
          }
        };
      }());
      var child2 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.restaurants.unrestricted"], {});
            return fragment;
          }
        };
      }());
      var child3 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            content(env, morph0, context, "item.name");
            return fragment;
          }
        };
      }());
      var child4 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption warning");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            var morph1 = dom.createMorphAt(dom.childAt(fragment, [1]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.restaurants.restricted_header"], {});
            inline(env, morph1, context, "t", ["promos.edit.restaurants.restricted_comment"], {});
            return fragment;
          }
        };
      }());
      var child5 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.sources.unrestricted"], {});
            return fragment;
          }
        };
      }());
      var child6 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            inline(env, morph0, context, "t2", ["clients.order_source", get(env, context, "item")], {});
            return fragment;
          }
        };
      }());
      var child7 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption warning");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            var morph1 = dom.createMorphAt(dom.childAt(fragment, [1]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.sources.restricted_header"], {});
            inline(env, morph1, context, "t", ["promos.edit.sources.restricted_comment"], {});
            return fragment;
          }
        };
      }());
      var child8 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child9 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child10 = (function() {
        var child0 = (function() {
          var child0 = (function() {
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, inline = hooks.inline;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                inline(env, morph0, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.stat.report", "classNames": "small primary", "action": "viewPromoCodes"});
                inline(env, morph1, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.stat.download", "classNames": "small orange", "action": "exportPromoCodes"});
                return fragment;
              }
            };
          }());
          var child1 = (function() {
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, get = hooks.get, inline = hooks.inline;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                inline(env, morph0, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.stat.delete_unused", "classNames": "small", "isLoading": get(env, context, "isPromoCodesDeleting"), "action": "deleteUnusedPromoCodes"});
                return fragment;
              }
            };
          }());
          var child2 = (function() {
            var child0 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  var el1 = dom.createComment("");
                  dom.appendChild(el0, el1);
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  var hooks = env.hooks, inline = hooks.inline;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                  dom.insertBoundary(fragment, null);
                  dom.insertBoundary(fragment, 0);
                  inline(env, morph0, context, "t", ["promos.edit.single_use_codes.create.title_more"], {});
                  return fragment;
                }
              };
            }());
            var child1 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  var el1 = dom.createComment("");
                  dom.appendChild(el0, el1);
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  var hooks = env.hooks, inline = hooks.inline;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                  dom.insertBoundary(fragment, null);
                  dom.insertBoundary(fragment, 0);
                  inline(env, morph0, context, "t", ["promos.edit.single_use_codes.create.title"], {});
                  return fragment;
                }
              };
            }());
            var child2 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  return fragment;
                }
              };
            }());
            var child3 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  return fragment;
                }
              };
            }());
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createElement("div");
                dom.setAttribute(el1,"class","form-group-horizontal");
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","control-label");
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","form-control create-promo-codes");
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","inputs");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","caption");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, get = hooks.get, block = hooks.block, inline = hooks.inline;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var element31 = dom.childAt(fragment, [0]);
                var element32 = dom.childAt(element31, [1]);
                var element33 = dom.childAt(element32, [0]);
                var morph0 = dom.createMorphAt(dom.childAt(element31, [0]),0,0);
                var morph1 = dom.createMorphAt(element33,0,0);
                var morph2 = dom.createMorphAt(element33,1,1);
                var morph3 = dom.createMorphAt(element33,2,2);
                var morph4 = dom.createMorphAt(dom.childAt(element32, [1]),0,0);
                block(env, morph0, context, "if", [get(env, context, "has_promo_codes")], {}, child0, child1);
                block(env, morph1, context, "sm-text-field", [], {"placeholderTranslation": "promos.edit.single_use_codes.create.amount", "value": get(env, context, "promoCodesAmount"), "onChange": "onPromoCodesAmountChanged"}, child2, null);
                block(env, morph2, context, "sm-text-field", [], {"placeholderTranslation": "promos.edit.single_use_codes.create.length", "value": get(env, context, "promoCodesLength"), "onChange": "onPromoCodesLengthChanged"}, child3, null);
                inline(env, morph3, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.create.button", "classNames": "primary", "disabled": get(env, context, "isPromoCodesCreatingDisabled"), "isLoading": get(env, context, "isPromoCodesCreating"), "action": "createPromoCodes"});
                inline(env, morph4, context, "t", ["promos.edit.single_use_codes.create.comment"], {});
                return fragment;
              }
            };
          }());
          var child3 = (function() {
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, inline = hooks.inline;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                inline(env, morph0, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.create.cancel", "classNames": "small gray", "action": "isPromoCodesCreatingFormShownToggle"});
                return fragment;
              }
            };
          }());
          var child4 = (function() {
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, inline = hooks.inline;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                inline(env, morph0, context, "sm-button", [], {"textTranslation": "promos.edit.single_use_codes.create.generate", "classNames": "small orange", "action": "isPromoCodesCreatingFormShownToggle"});
                return fragment;
              }
            };
          }());
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","form-group-horizontal");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","control-label");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-control once-only");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","caption number");
              var el4 = dom.createElement("span");
              var el5 = dom.createComment("");
              dom.appendChild(el4, el5);
              dom.appendChild(el3, el4);
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","form-group-horizontal");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","control-label");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-control once-only");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","caption number");
              var el4 = dom.createElement("span");
              var el5 = dom.createComment("");
              dom.appendChild(el4, el5);
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","form-group-horizontal");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","control-label");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-control once-only");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","caption number");
              var el4 = dom.createElement("span");
              var el5 = dom.createComment("");
              dom.appendChild(el4, el5);
              dom.appendChild(el3, el4);
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              var el1 = dom.createComment("");
              dom.appendChild(el0, el1);
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","form-group-horizontal");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","control-label");
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-control once-only");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, inline = hooks.inline, content = hooks.content, get = hooks.get, block = hooks.block;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var element34 = dom.childAt(fragment, [0]);
              var element35 = dom.childAt(element34, [1, 0]);
              var element36 = dom.childAt(fragment, [1]);
              var element37 = dom.childAt(fragment, [2]);
              var element38 = dom.childAt(element37, [1, 0]);
              var morph0 = dom.createMorphAt(dom.childAt(element34, [0]),0,0);
              var morph1 = dom.createMorphAt(dom.childAt(element35, [0]),0,0);
              var morph2 = dom.createMorphAt(element35,1,1);
              var morph3 = dom.createMorphAt(dom.childAt(element36, [0]),0,0);
              var morph4 = dom.createMorphAt(dom.childAt(element36, [1, 0, 0]),0,0);
              var morph5 = dom.createMorphAt(dom.childAt(element37, [0]),0,0);
              var morph6 = dom.createMorphAt(dom.childAt(element38, [0]),0,0);
              var morph7 = dom.createMorphAt(element38,1,1);
              var morph8 = dom.createMorphAt(fragment,3,3,contextualElement);
              var morph9 = dom.createMorphAt(dom.childAt(fragment, [4, 1]),0,0);
              inline(env, morph0, context, "t", ["promos.edit.single_use_codes.stat.label"], {});
              content(env, morph1, context, "promo.promo_codes_available");
              block(env, morph2, context, "if", [get(env, context, "has_promo_codes")], {}, child0, null);
              inline(env, morph3, context, "t", ["promos.edit.single_use_codes.stat.used"], {});
              content(env, morph4, context, "promo.promo_codes_used");
              inline(env, morph5, context, "t", ["promos.edit.single_use_codes.stat.available"], {});
              content(env, morph6, context, "promo.promo_codes_unused");
              block(env, morph7, context, "if", [get(env, context, "has_promo_codes_unused")], {}, child1, null);
              block(env, morph8, context, "if", [get(env, context, "isPromoCodesCreatingFormShown")], {}, child2, null);
              block(env, morph9, context, "if", [get(env, context, "isPromoCodesCreatingFormShown")], {}, child3, child4);
              return fragment;
            }
          };
        }());
        var child1 = (function() {
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","form-group-horizontal");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","control-label");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-control once-only");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","caption");
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, inline = hooks.inline;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var element30 = dom.childAt(fragment, [0]);
              var morph0 = dom.createMorphAt(dom.childAt(element30, [0]),0,0);
              var morph1 = dom.createMorphAt(dom.childAt(element30, [1, 0]),0,0);
              inline(env, morph0, context, "t", ["promos.edit.single_use_codes.create.title"], {});
              inline(env, morph1, context, "t", ["promos.edit.single_use_codes.create.need_save"], {});
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            block(env, morph0, context, "if", [get(env, context, "promo.id")], {}, child0, child1);
            return fragment;
          }
        };
      }());
      var child11 = (function() {
        var child0 = (function() {
          var child0 = (function() {
            var child0 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  return fragment;
                }
              };
            }());
            var child1 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  return fragment;
                }
              };
            }());
            var child2 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  return fragment;
                }
              };
            }());
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createElement("div");
                dom.setAttribute(el1,"class","form-group-horizontal");
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","control-label");
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","form-control");
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","inputs");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","caption");
                var el4 = dom.createElement("p");
                var el5 = dom.createComment("");
                dom.appendChild(el4, el5);
                dom.appendChild(el3, el4);
                var el4 = dom.createElement("div");
                dom.setAttribute(el4,"class","tag");
                var el5 = dom.createComment("");
                dom.appendChild(el4, el5);
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                dom.appendChild(el0, el1);
                var el1 = dom.createElement("div");
                dom.setAttribute(el1,"class","form-group-horizontal");
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","control-label");
                var el3 = dom.createTextNode(" ");
                dom.appendChild(el2, el3);
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","form-control");
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","inputs");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","caption");
                var el4 = dom.createTextNode(" ");
                dom.appendChild(el3, el4);
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                dom.appendChild(el0, el1);
                var el1 = dom.createElement("div");
                dom.setAttribute(el1,"class","form-group-horizontal");
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","control-label");
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","form-control");
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","inputs");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                var el3 = dom.createElement("div");
                dom.setAttribute(el3,"class","caption");
                var el4 = dom.createComment("");
                dom.appendChild(el3, el4);
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                dom.appendChild(el0, el1);
                var el1 = dom.createElement("div");
                dom.setAttribute(el1,"class","form-group-horizontal");
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","control-label");
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                var el2 = dom.createElement("div");
                dom.setAttribute(el2,"class","form-control once-only");
                var el3 = dom.createComment("");
                dom.appendChild(el2, el3);
                dom.appendChild(el1, el2);
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var element19 = dom.childAt(fragment, [0]);
                var element20 = dom.childAt(element19, [1]);
                var element21 = dom.childAt(element20, [1]);
                var element22 = dom.childAt(fragment, [1]);
                var element23 = dom.childAt(element22, [1]);
                var element24 = dom.childAt(fragment, [2]);
                var element25 = dom.childAt(element24, [1]);
                var element26 = dom.childAt(fragment, [3]);
                var morph0 = dom.createMorphAt(dom.childAt(element19, [0]),0,0);
                var morph1 = dom.createMorphAt(dom.childAt(element20, [0]),0,0);
                var morph2 = dom.createMorphAt(dom.childAt(element21, [0]),0,0);
                var morph3 = dom.createMorphAt(dom.childAt(element21, [1]),0,0);
                var morph4 = dom.createMorphAt(dom.childAt(element22, [0]),1,1);
                var morph5 = dom.createMorphAt(dom.childAt(element23, [0]),0,0);
                var morph6 = dom.createMorphAt(dom.childAt(element23, [1]),1,1);
                var morph7 = dom.createMorphAt(dom.childAt(element24, [0]),0,0);
                var morph8 = dom.createMorphAt(dom.childAt(element25, [0]),0,0);
                var morph9 = dom.createMorphAt(dom.childAt(element25, [1]),0,0);
                var morph10 = dom.createMorphAt(dom.childAt(element26, [0]),0,0);
                var morph11 = dom.createMorphAt(dom.childAt(element26, [1]),0,0);
                inline(env, morph0, context, "t", ["promos.edit.promos_issue.issue_sms_text.label"], {});
                block(env, morph1, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.promos_issue.issue_sms_text.placeholder", "value": get(env, context, "promo.issue_sms_text")}, child0, null);
                inline(env, morph2, context, "t", ["promos.edit.promos_issue.issue_sms_text.example.label"], {});
                inline(env, morph3, context, "t", ["promos.edit.promos_issue.issue_sms_text.example.text"], {});
                inline(env, morph4, context, "t", ["promos.edit.promos_issue.length.label"], {});
                block(env, morph5, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholder": "promos.edit.promos_issue.length.placeholder", "value": get(env, context, "promo.issue_code_length")}, child1, null);
                inline(env, morph6, context, "t", ["promos.edit.promos_issue.length.caption"], {});
                inline(env, morph7, context, "t", ["promos.edit.promos_issue.ttl.label"], {});
                block(env, morph8, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholderTranslation": "promos.edit.promos_issue.ttl.placeholder", "value": get(env, context, "promo.issue_code_ttl")}, child2, null);
                inline(env, morph9, context, "t", ["promos.edit.promos_issue.ttl.caption"], {});
                inline(env, morph10, context, "t", ["promos.edit.promos_issue.manual_enable"], {});
                inline(env, morph11, context, "sm-toggle", [], {"checked": get(env, context, "promo.manual_issue_enabled")});
                return fragment;
              }
            };
          }());
          var child1 = (function() {
            var child0 = (function() {
              var child0 = (function() {
                var child0 = (function() {
                  return {
                    isHTMLBars: true,
                    revision: "Ember@1.11.1",
                    blockParams: 0,
                    cachedFragment: null,
                    hasRendered: false,
                    build: function build(dom) {
                      var el0 = dom.createDocumentFragment();
                      return el0;
                    },
                    render: function render(context, env, contextualElement) {
                      var dom = env.dom;
                      dom.detectNamespace(contextualElement);
                      var fragment;
                      if (env.useFragmentCache && dom.canClone) {
                        if (this.cachedFragment === null) {
                          fragment = this.build(dom);
                          if (this.hasRendered) {
                            this.cachedFragment = fragment;
                          } else {
                            this.hasRendered = true;
                          }
                        }
                        if (this.cachedFragment) {
                          fragment = dom.cloneNode(this.cachedFragment, true);
                        }
                      } else {
                        fragment = this.build(dom);
                      }
                      return fragment;
                    }
                  };
                }());
                return {
                  isHTMLBars: true,
                  revision: "Ember@1.11.1",
                  blockParams: 0,
                  cachedFragment: null,
                  hasRendered: false,
                  build: function build(dom) {
                    var el0 = dom.createDocumentFragment();
                    var el1 = dom.createElement("div");
                    dom.setAttribute(el1,"class","form-group-horizontal");
                    var el2 = dom.createElement("div");
                    dom.setAttribute(el2,"class","control-label");
                    var el3 = dom.createTextNode(" ");
                    dom.appendChild(el2, el3);
                    var el3 = dom.createComment("");
                    dom.appendChild(el2, el3);
                    dom.appendChild(el1, el2);
                    var el2 = dom.createElement("div");
                    dom.setAttribute(el2,"class","form-control");
                    var el3 = dom.createElement("div");
                    dom.setAttribute(el3,"class","inputs");
                    var el4 = dom.createComment("");
                    dom.appendChild(el3, el4);
                    dom.appendChild(el2, el3);
                    dom.appendChild(el1, el2);
                    dom.appendChild(el0, el1);
                    return el0;
                  },
                  render: function render(context, env, contextualElement) {
                    var dom = env.dom;
                    var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
                    dom.detectNamespace(contextualElement);
                    var fragment;
                    if (env.useFragmentCache && dom.canClone) {
                      if (this.cachedFragment === null) {
                        fragment = this.build(dom);
                        if (this.hasRendered) {
                          this.cachedFragment = fragment;
                        } else {
                          this.hasRendered = true;
                        }
                      }
                      if (this.cachedFragment) {
                        fragment = dom.cloneNode(this.cachedFragment, true);
                      }
                    } else {
                      fragment = this.build(dom);
                    }
                    var element15 = dom.childAt(fragment, [0]);
                    var morph0 = dom.createMorphAt(dom.childAt(element15, [0]),1,1);
                    var morph1 = dom.createMorphAt(dom.childAt(element15, [1, 0]),0,0);
                    inline(env, morph0, context, "t", ["promos.edit.issue_late.minutes_amount.label"], {});
                    block(env, morph1, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "placeholderTranslation": "promos.edit.issue_late.minutes_amount.placeholder", "value": get(env, context, "promo.late_issue_minutes_amount")}, child0, null);
                    return fragment;
                  }
                };
              }());
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  var el1 = dom.createElement("div");
                  dom.setAttribute(el1,"class","plain-form-subheader");
                  var el2 = dom.createElement("h1");
                  var el3 = dom.createComment("");
                  dom.appendChild(el2, el3);
                  dom.appendChild(el1, el2);
                  var el2 = dom.createElement("h2");
                  var el3 = dom.createComment("");
                  dom.appendChild(el2, el3);
                  dom.appendChild(el1, el2);
                  dom.appendChild(el0, el1);
                  var el1 = dom.createElement("div");
                  dom.setAttribute(el1,"class","plain-form-section");
                  var el2 = dom.createElement("div");
                  dom.setAttribute(el2,"class","form-group-horizontal");
                  var el3 = dom.createElement("div");
                  dom.setAttribute(el3,"class","control-label");
                  var el4 = dom.createComment("");
                  dom.appendChild(el3, el4);
                  dom.appendChild(el2, el3);
                  var el3 = dom.createElement("div");
                  dom.setAttribute(el3,"class","form-control once-only");
                  var el4 = dom.createComment("");
                  dom.appendChild(el3, el4);
                  dom.appendChild(el2, el3);
                  dom.appendChild(el1, el2);
                  var el2 = dom.createComment("");
                  dom.appendChild(el1, el2);
                  dom.appendChild(el0, el1);
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  var element16 = dom.childAt(fragment, [0]);
                  var element17 = dom.childAt(fragment, [1]);
                  var element18 = dom.childAt(element17, [0]);
                  var morph0 = dom.createMorphAt(dom.childAt(element16, [0]),0,0);
                  var morph1 = dom.createMorphAt(dom.childAt(element16, [1]),0,0);
                  var morph2 = dom.createMorphAt(dom.childAt(element18, [0]),0,0);
                  var morph3 = dom.createMorphAt(dom.childAt(element18, [1]),0,0);
                  var morph4 = dom.createMorphAt(element17,1,1);
                  inline(env, morph0, context, "t", ["promos.edit.issue_late.header"], {});
                  inline(env, morph1, context, "t", ["promos.edit.issue_late.comment"], {});
                  inline(env, morph2, context, "t", ["promos.edit.issue_late.enable.label"], {});
                  inline(env, morph3, context, "sm-toggle", [], {"checked": get(env, context, "promo.late_issue_enabled")});
                  block(env, morph4, context, "if", [get(env, context, "promo.late_issue_enabled")], {}, child0, null);
                  return fragment;
                }
              };
            }());
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, get = hooks.get, block = hooks.block;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                block(env, morph0, context, "if", [get(env, context, "promo.organization.features.promos_issue_late_enabled")], {}, child0, null);
                return fragment;
              }
            };
          }());
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","plain-form-subheader");
              var el2 = dom.createElement("h1");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("h2");
              var el3 = dom.createComment("");
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","plain-form-section");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","form-group-horizontal");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","control-label");
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","form-control once-only");
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              var el2 = dom.createComment("");
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              var el1 = dom.createComment("");
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var element27 = dom.childAt(fragment, [0]);
              var element28 = dom.childAt(fragment, [1]);
              var element29 = dom.childAt(element28, [0]);
              var morph0 = dom.createMorphAt(dom.childAt(element27, [0]),0,0);
              var morph1 = dom.createMorphAt(dom.childAt(element27, [1]),0,0);
              var morph2 = dom.createMorphAt(dom.childAt(element29, [0]),0,0);
              var morph3 = dom.createMorphAt(dom.childAt(element29, [1]),0,0);
              var morph4 = dom.createMorphAt(element28,1,1);
              var morph5 = dom.createMorphAt(fragment,2,2,contextualElement);
              dom.insertBoundary(fragment, null);
              inline(env, morph0, context, "t", ["promos.edit.promos_issue.header"], {});
              inline(env, morph1, context, "t", ["promos.edit.promos_issue.comment"], {});
              inline(env, morph2, context, "t", ["promos.edit.promos_issue.enable.label"], {});
              inline(env, morph3, context, "sm-toggle", [], {"checked": get(env, context, "promo.issue_enabled")});
              block(env, morph4, context, "if", [get(env, context, "promo.issue_enabled")], {}, child0, null);
              block(env, morph5, context, "if", [get(env, context, "promo.issue_enabled")], {}, child1, null);
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            block(env, morph0, context, "if", [get(env, context, "promo.organization.features.promos_issue_enabled")], {}, child0, null);
            return fragment;
          }
        };
      }());
      var child12 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child13 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            return fragment;
          }
        };
      }());
      var child14 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "dish", blockArguments[0]);
            inline(env, morph0, context, "dish-suggestion", [], {"dish": get(env, context, "dish")});
            return fragment;
          }
        };
      }());
      var child15 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "category", blockArguments[0]);
            content(env, morph0, context, "category.name");
            return fragment;
          }
        };
      }());
      var child16 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "dish", blockArguments[0]);
            inline(env, morph0, context, "dish-suggestion", [], {"dish": get(env, context, "dish")});
            return fragment;
          }
        };
      }());
      var child17 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            content(env, morph0, context, "item.name");
            return fragment;
          }
        };
      }());
      var child18 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            content(env, morph0, context, "item.name");
            return fragment;
          }
        };
      }());
      var child19 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            inline(env, morph0, context, "t2", ["clients.recurrence_label", get(env, context, "item")], {});
            return fragment;
          }
        };
      }());
      var child20 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("span");
            dom.setAttribute(el1,"class","hint");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.client_requirements.order_sum.warning"], {});
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal restaurant-select");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal restaurant-select");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createTextNode(" ");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createTextNode(" ");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createTextNode(" ");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createTextNode(" ");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block, element = hooks.element;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var element45 = dom.childAt(fragment, [0]);
          var element46 = dom.childAt(element45, [0]);
          var element47 = dom.childAt(element46, [1]);
          var element48 = dom.childAt(fragment, [1]);
          var element49 = dom.childAt(element48, [0]);
          var element50 = dom.childAt(element49, [1]);
          var element51 = dom.childAt(element48, [1]);
          var element52 = dom.childAt(element51, [1]);
          var element53 = dom.childAt(element48, [2]);
          var element54 = dom.childAt(element53, [1]);
          var element55 = dom.childAt(element48, [3]);
          var element56 = dom.childAt(element48, [4]);
          var element57 = dom.childAt(element48, [5]);
          var element58 = dom.childAt(fragment, [2]);
          var element59 = dom.childAt(fragment, [3]);
          var element60 = dom.childAt(element59, [0]);
          var element61 = dom.childAt(element59, [1]);
          var element62 = dom.childAt(element61, [1]);
          var element63 = dom.childAt(element59, [2]);
          var element64 = dom.childAt(element63, [1]);
          var element65 = dom.childAt(fragment, [4]);
          var element66 = dom.childAt(fragment, [5]);
          var element67 = dom.childAt(element66, [0]);
          var element68 = dom.childAt(element67, [1]);
          var element69 = dom.childAt(fragment, [7]);
          var element70 = dom.childAt(fragment, [8]);
          var element71 = dom.childAt(element70, [0]);
          var element72 = dom.childAt(element71, [1]);
          var element73 = dom.childAt(element70, [1]);
          var element74 = dom.childAt(element73, [1]);
          var element75 = dom.childAt(fragment, [9]);
          var element76 = dom.childAt(fragment, [10, 0]);
          var element77 = dom.childAt(fragment, [11]);
          var element78 = dom.childAt(fragment, [12]);
          var element79 = dom.childAt(element78, [0]);
          var element80 = dom.childAt(element78, [1]);
          var element81 = dom.childAt(element78, [2]);
          var element82 = dom.childAt(fragment, [14]);
          var element83 = dom.childAt(element82, [0]);
          var element84 = dom.childAt(element83, [1]);
          var element85 = dom.childAt(element82, [1]);
          var element86 = dom.childAt(element85, [1]);
          var element87 = dom.childAt(element82, [2]);
          var element88 = dom.childAt(element87, [1]);
          var element89 = dom.childAt(element82, [3]);
          var element90 = dom.childAt(element82, [4]);
          var element91 = dom.childAt(element90, [1, 0]);
          var element92 = dom.childAt(element82, [5]);
          var element93 = dom.childAt(element92, [1]);
          var element94 = dom.childAt(element82, [6]);
          var element95 = dom.childAt(element94, [1]);
          var morph0 = dom.createMorphAt(dom.childAt(element46, [0]),0,0);
          var morph1 = dom.createMorphAt(element47,0,0);
          var morph2 = dom.createMorphAt(dom.childAt(element47, [1]),0,0);
          var morph3 = dom.createMorphAt(element45,1,1);
          var morph4 = dom.createMorphAt(element45,2,2);
          var morph5 = dom.createMorphAt(dom.childAt(element49, [0]),0,0);
          var morph6 = dom.createMorphAt(element50,0,0);
          var morph7 = dom.createMorphAt(dom.childAt(element50, [1]),0,0);
          var morph8 = dom.createMorphAt(dom.childAt(element51, [0]),0,0);
          var morph9 = dom.createMorphAt(element52,0,0);
          var morph10 = dom.createMorphAt(element52,1,1);
          var morph11 = dom.createMorphAt(element52,2,2);
          var morph12 = dom.createMorphAt(dom.childAt(element53, [0]),0,0);
          var morph13 = dom.createMorphAt(element54,0,0);
          var morph14 = dom.createMorphAt(element54,1,1);
          var morph15 = dom.createMorphAt(element54,2,2);
          var morph16 = dom.createMorphAt(dom.childAt(element55, [0]),0,0);
          var morph17 = dom.createMorphAt(dom.childAt(element55, [1]),0,0);
          var morph18 = dom.createMorphAt(dom.childAt(element56, [0]),0,0);
          var morph19 = dom.createMorphAt(dom.childAt(element56, [1]),0,0);
          var morph20 = dom.createMorphAt(dom.childAt(element57, [0]),0,0);
          var morph21 = dom.createMorphAt(dom.childAt(element57, [1]),0,0);
          var morph22 = dom.createMorphAt(dom.childAt(element58, [0]),0,0);
          var morph23 = dom.createMorphAt(dom.childAt(element58, [1]),0,0);
          var morph24 = dom.createMorphAt(dom.childAt(element60, [0]),0,0);
          var morph25 = dom.createMorphAt(dom.childAt(element60, [1, 0]),0,0);
          var morph26 = dom.createMorphAt(dom.childAt(element61, [0]),1,1);
          var morph27 = dom.createMorphAt(dom.childAt(element62, [0]),0,0);
          var morph28 = dom.createMorphAt(dom.childAt(element62, [1]),0,0);
          var morph29 = dom.createMorphAt(dom.childAt(element63, [0]),0,0);
          var morph30 = dom.createMorphAt(dom.childAt(element64, [0]),0,0);
          var morph31 = dom.createMorphAt(dom.childAt(element64, [1]),0,0);
          var morph32 = dom.createMorphAt(dom.childAt(element65, [0]),0,0);
          var morph33 = dom.createMorphAt(dom.childAt(element65, [1]),0,0);
          var morph34 = dom.createMorphAt(dom.childAt(element67, [0]),0,0);
          var morph35 = dom.createMorphAt(element68,0,0);
          var morph36 = dom.createMorphAt(dom.childAt(element68, [1]),0,0);
          var morph37 = dom.createMorphAt(element66,1,1);
          var morph38 = dom.createMorphAt(fragment,6,6,contextualElement);
          var morph39 = dom.createMorphAt(dom.childAt(element69, [0]),0,0);
          var morph40 = dom.createMorphAt(dom.childAt(element69, [1]),0,0);
          var morph41 = dom.createMorphAt(dom.childAt(element71, [0]),1,1);
          var morph42 = dom.createMorphAt(dom.childAt(element72, [0]),0,0);
          var morph43 = dom.createMorphAt(dom.childAt(element72, [1]),0,0);
          var morph44 = dom.createMorphAt(dom.childAt(element73, [0]),0,0);
          var morph45 = dom.createMorphAt(dom.childAt(element74, [0]),0,0);
          var morph46 = dom.createMorphAt(dom.childAt(element74, [1]),0,0);
          var morph47 = dom.createMorphAt(dom.childAt(element75, [0]),0,0);
          var morph48 = dom.createMorphAt(dom.childAt(element75, [1]),0,0);
          var morph49 = dom.createMorphAt(dom.childAt(element76, [0]),1,1);
          var morph50 = dom.createMorphAt(dom.childAt(element76, [1]),0,0);
          var morph51 = dom.createMorphAt(dom.childAt(element77, [0]),0,0);
          var morph52 = dom.createMorphAt(dom.childAt(element77, [1]),0,0);
          var morph53 = dom.createMorphAt(dom.childAt(element79, [0]),0,0);
          var morph54 = dom.createMorphAt(dom.childAt(element79, [1]),0,0);
          var morph55 = dom.createMorphAt(dom.childAt(element80, [0]),0,0);
          var morph56 = dom.createMorphAt(dom.childAt(element80, [1]),0,0);
          var morph57 = dom.createMorphAt(dom.childAt(element81, [0]),0,0);
          var morph58 = dom.createMorphAt(dom.childAt(element81, [1]),0,0);
          var morph59 = dom.createMorphAt(dom.childAt(fragment, [13, 0]),0,0);
          var morph60 = dom.createMorphAt(dom.childAt(element83, [0]),0,0);
          var morph61 = dom.createMorphAt(element84,0,0);
          var morph62 = dom.createMorphAt(dom.childAt(element84, [1]),0,0);
          var morph63 = dom.createMorphAt(dom.childAt(element85, [0]),0,0);
          var morph64 = dom.createMorphAt(element86,0,0);
          var morph65 = dom.createMorphAt(dom.childAt(element86, [1]),0,0);
          var morph66 = dom.createMorphAt(dom.childAt(element87, [0]),0,0);
          var morph67 = dom.createMorphAt(element88,0,0);
          var morph68 = dom.createMorphAt(dom.childAt(element88, [1]),0,0);
          var morph69 = dom.createMorphAt(dom.childAt(element89, [0]),1,1);
          var morph70 = dom.createMorphAt(dom.childAt(element89, [1, 0]),0,0);
          var morph71 = dom.createMorphAt(dom.childAt(element90, [0]),0,0);
          var morph72 = dom.createMorphAt(element91,0,0);
          var morph73 = dom.createMorphAt(element91,1,1);
          var morph74 = dom.createMorphAt(dom.childAt(element92, [0]),0,0);
          var morph75 = dom.createMorphAt(element93,0,0);
          var morph76 = dom.createMorphAt(dom.childAt(element93, [1]),0,0);
          var morph77 = dom.createMorphAt(dom.childAt(element94, [0]),0,0);
          var morph78 = dom.createMorphAt(dom.childAt(element95, [0]),0,0);
          var morph79 = dom.createMorphAt(dom.childAt(element95, [1]),0,0);
          inline(env, morph0, context, "t", ["promos.edit.for_birthday.label"], {});
          inline(env, morph1, context, "sm-toggle", [], {"checked": get(env, context, "promo.for_birthday")});
          inline(env, morph2, context, "t", ["promos.edit.for_birthday.caption"], {});
          block(env, morph3, context, "if", [get(env, context, "promo.for_birthday")], {}, child0, null);
          block(env, morph4, context, "if", [get(env, context, "promo.timetable_enabled")], {}, child1, null);
          inline(env, morph5, context, "t", ["promos.edit.is_exclusive.label"], {});
          inline(env, morph6, context, "sm-toggle", [], {"checked": get(env, context, "promo.is_exclusive")});
          inline(env, morph7, context, "t", ["promos.edit.is_exclusive.caption"], {});
          inline(env, morph8, context, "t", ["promos.edit.restaurants.label"], {});
          block(env, morph9, context, "unless", [get(env, context, "promo.restaurants")], {}, child2, null);
          block(env, morph10, context, "sm-chosen", [], {"searchEnabled": true, "insertEnabled": false, "content": get(env, context, "promo.restaurants"), "labelPath": ".name", "collection": get(env, context, "restaurants")}, child3, null);
          block(env, morph11, context, "if", [get(env, context, "promo.restaurants")], {}, child4, null);
          inline(env, morph12, context, "t", ["promos.edit.sources.label"], {});
          block(env, morph13, context, "unless", [get(env, context, "promo.sources")], {}, child5, null);
          block(env, morph14, context, "sm-chosen", [], {"onAddItem": "addSource", "onRemoveItem": "removeSource", "insertEnabled": false, "content": get(env, context, "promo.sources_array"), "labelTranslation": "clients.order_source", "collection": get(env, context, "sources")}, child6, null);
          block(env, morph15, context, "if", [get(env, context, "promo.sources")], {}, child7, null);
          inline(env, morph16, context, "t", ["promos.edit.inversed_delay"], {});
          inline(env, morph17, context, "sm-toggle", [], {"checked": get(env, context, "promo.inversed_delay")});
          inline(env, morph18, context, "t", ["promos.edit.disposable"], {});
          inline(env, morph19, context, "sm-toggle", [], {"checked": get(env, context, "promo.disposable")});
          inline(env, morph20, context, "t", ["promos.edit.for_referral"], {});
          inline(env, morph21, context, "sm-toggle", [], {"checked": get(env, context, "promo.for_referral")});
          inline(env, morph22, context, "t", ["promos.edit.last_order.header"], {});
          inline(env, morph23, context, "t", ["promos.edit.last_order.comment"], {});
          inline(env, morph24, context, "t", ["promos.edit.last_order.sum.label"], {});
          block(env, morph25, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.last_order.sum.placeholder", "value": get(env, context, "promo.next_order_min_sum")}, child8, null);
          inline(env, morph26, context, "t", ["promos.edit.client_requirements.nth_order.label"], {});
          inline(env, morph27, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.order_nth"), "min": "1"});
          inline(env, morph28, context, "t", ["promos.edit.client_requirements.nth_order.caption"], {});
          inline(env, morph29, context, "t", ["promos.edit.last_order.days_count.label"], {});
          block(env, morph30, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.last_order.days_count.placeholder", "value": get(env, context, "promo.next_order_in_days")}, child9, null);
          inline(env, morph31, context, "t", ["promos.edit.last_order.days_count.caption"], {});
          inline(env, morph32, context, "t", ["promos.edit.single_use_codes.header"], {});
          inline(env, morph33, context, "t", ["promos.edit.single_use_codes.comment"], {});
          inline(env, morph34, context, "t", ["promos.edit.single_use_codes.enabled.label"], {});
          inline(env, morph35, context, "sm-toggle", [], {"checked": get(env, context, "promo.promo_codes_enabled")});
          inline(env, morph36, context, "t", ["promos.edit.single_use_codes.enabled.caption"], {});
          block(env, morph37, context, "if", [get(env, context, "promo.promo_codes_enabled")], {}, child10, null);
          block(env, morph38, context, "if", [get(env, context, "promo.promo_codes_enabled")], {}, child11, null);
          inline(env, morph39, context, "t", ["promos.edit.codes.header"], {});
          inline(env, morph40, context, "t", ["promos.edit.codes.comment"], {});
          inline(env, morph41, context, "t", ["promos.edit.codes.code.label"], {});
          block(env, morph42, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.codes.code.placeholder", "value": get(env, context, "promo.code")}, child12, null);
          inline(env, morph43, context, "t", ["promos.edit.codes.code.caption"], {});
          inline(env, morph44, context, "t", ["promos.edit.error_text.label"], {});
          block(env, morph45, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "promos.edit.error_text.placeholder", "value": get(env, context, "promo.invalid_code_message")}, child13, null);
          inline(env, morph46, context, "t", ["promos.edit.error_text.caption"], {});
          inline(env, morph47, context, "t", ["promos.edit.required_all_dishes.header"], {});
          inline(env, morph48, context, "t", ["promos.edit.required_all_dishes.comment"], {});
          inline(env, morph49, context, "t", ["promos.edit.required_all_dishes.label"], {});
          block(env, morph50, context, "sm-chosen", [], {"classNames": "dishes-chosen", "content": get(env, context, "promo.required_all_dishes"), "labelPath": "name", "onQuery": "queryDishes", "onLoadMore": "loadMoreDishes", "insertEnabled": false}, child14, null);
          inline(env, morph51, context, "t", ["promos.edit.required_any_dish.header"], {});
          inline(env, morph52, context, "t", ["promos.edit.required_any_dish.comment"], {});
          inline(env, morph53, context, "t", ["promos.edit.required_any_dish_categories.label"], {});
          block(env, morph54, context, "sm-chosen", [], {"content": get(env, context, "promo.required_any_dish_categories"), "labelPath": "name", "onQuery": "queryCategories", "insertEnabled": false}, child15, null);
          inline(env, morph55, context, "t", ["promos.edit.required_any_dish.label"], {});
          block(env, morph56, context, "sm-chosen", [], {"classNames": "dishes-chosen", "content": get(env, context, "promo.required_any_dishes"), "labelPath": "name", "onQuery": "queryDishes", "onLoadMore": "loadMoreDishes", "insertEnabled": false}, child16, null);
          inline(env, morph57, context, "t", ["promos.edit.required_any_dish.number"], {});
          inline(env, morph58, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.required_any_dishes_count"), "min": 1});
          inline(env, morph59, context, "t", ["promos.edit.client_requirements.header"], {});
          inline(env, morph60, context, "t", ["promos.edit.client_requirements.category.label"], {});
          block(env, morph61, context, "sm-chosen", [], {"content": get(env, context, "promo.client_tags"), "labelPath": "name", "onQuery": "queryTags", "searchEnabled": false, "insertEnabled": false}, child17, null);
          inline(env, morph62, context, "t", ["promos.edit.client_requirements.category.caption"], {});
          inline(env, morph63, context, "t", ["promos.edit.client_requirements.restrict_category.label"], {});
          block(env, morph64, context, "sm-chosen", [], {"content": get(env, context, "promo.client_restrict_tags"), "labelPath": "name", "onQuery": "queryTags", "searchEnabled": false, "insertEnabled": false}, child18, null);
          inline(env, morph65, context, "t", ["promos.edit.client_requirements.restrict_category.caption"], {});
          inline(env, morph66, context, "t", ["promos.edit.client_requirements.recurrence.label"], {});
          block(env, morph67, context, "sm-chosen", [], {"onAddItem": "addRecurrence", "onRemoveItem": "removeRecurrence", "insertEnabled": false, "content": get(env, context, "promo.recurrences_array"), "labelTranslation": "clients.recurrence_label", "collection": get(env, context, "recurrences")}, child19, null);
          inline(env, morph68, context, "t", ["promos.edit.client_requirements.recurrence.caption"], {});
          inline(env, morph69, context, "t", ["promos.edit.client_requirements.order_sum.label"], {});
          inline(env, morph70, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.order_sum")});
          element(env, element90, context, "bind-attr", [], {"class": ":form-group-horizontal promo.order_sum::disabled"});
          inline(env, morph71, context, "t", ["promos.edit.client_requirements.count_order_sum_with_delivery.label"], {});
          inline(env, morph72, context, "sm-toggle", [], {"checked": get(env, context, "promo.count_order_sum_with_delivery")});
          block(env, morph73, context, "unless", [get(env, context, "promo.order_sum")], {}, child20, null);
          inline(env, morph74, context, "t", ["promos.edit.client_requirements.repeatable_bonus.label"], {});
          inline(env, morph75, context, "sm-toggle", [], {"checked": get(env, context, "promo.repeatable_bonus")});
          inline(env, morph76, context, "t", ["promos.edit.client_requirements.repeatable_bonus.caption"], {});
          inline(env, morph77, context, "t", ["promos.edit.client_requirements.for_new_client.label"], {});
          inline(env, morph78, context, "sm-toggle", [], {"checked": get(env, context, "promo.for_new_client")});
          inline(env, morph79, context, "t", ["promos.edit.client_requirements.for_new_client.caption"], {});
          return fragment;
        }
      };
    }());
    var child3 = (function() {
      var child0 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "dish", blockArguments[0]);
            inline(env, morph0, context, "dish-suggestion", [], {"dish": get(env, context, "dish")});
            return fragment;
          }
        };
      }());
      var child1 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, get = hooks.get, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "dish", blockArguments[0]);
            inline(env, morph0, context, "dish-suggestion", [], {"dish": get(env, context, "dish")});
            return fragment;
          }
        };
      }());
      var child2 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            inline(env, morph0, context, "t", ["promos.edit.bonuses.discount_dishes_percent.single_dish"], {});
            return fragment;
          }
        };
      }());
      var child3 = (function() {
        var child0 = (function() {
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createComment("");
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, inline = hooks.inline;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
              dom.insertBoundary(fragment, null);
              dom.insertBoundary(fragment, 0);
              inline(env, morph0, context, "t", ["promos.edit.bonuses.discount_dishes_percent.cheapest.enable"], {});
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","caption");
            var el2 = dom.createComment("");
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
            var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
            dom.insertBoundary(fragment, null);
            inline(env, morph0, context, "t", ["promos.edit.bonuses.discount_dishes_percent.cheapest.caption"], {});
            block(env, morph1, context, "sm-checkbox", [], {"checked": get(env, context, "promo.dishes_price_multiplier_single_dish_cheapest")}, child0, null);
            return fragment;
          }
        };
      }());
      var child4 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            content(env, morph0, context, "item.name");
            return fragment;
          }
        };
      }());
      var child5 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 1,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement, blockArguments) {
            var dom = env.dom;
            var hooks = env.hooks, set = hooks.set, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            set(env, context, "item", blockArguments[0]);
            content(env, morph0, context, "item.name");
            return fragment;
          }
        };
      }());
      var child6 = (function() {
        var child0 = (function() {
          var child0 = (function() {
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createTextNode("—");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                return fragment;
              }
            };
          }());
          var child1 = (function() {
            var child0 = (function() {
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  var el1 = dom.createComment("");
                  dom.appendChild(el0, el1);
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  var hooks = env.hooks, content = hooks.content;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                  dom.insertBoundary(fragment, null);
                  dom.insertBoundary(fragment, 0);
                  content(env, morph0, context, "p.name");
                  return fragment;
                }
              };
            }());
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 1,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement, blockArguments) {
                var dom = env.dom;
                var hooks = env.hooks, set = hooks.set, get = hooks.get, block = hooks.block;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                set(env, context, "p", blockArguments[0]);
                block(env, morph0, context, "sm-select-option", [], {"option": get(env, context, "p")}, child0, null);
                return fragment;
              }
            };
          }());
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createComment("");
              dom.appendChild(el0, el1);
              var el1 = dom.createComment("");
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, block = hooks.block, get = hooks.get;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
              var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
              dom.insertBoundary(fragment, null);
              dom.insertBoundary(fragment, 0);
              block(env, morph0, context, "sm-select-option", [], {}, child0, null);
              block(env, morph1, context, "each", [get(env, context, "promosIssues")], {}, child1, null);
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createElement("div");
            dom.setAttribute(el1,"class","form-group-horizontal");
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","control-label");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            var el2 = dom.createElement("div");
            dom.setAttribute(el2,"class","form-control");
            var el3 = dom.createComment("");
            dom.appendChild(el2, el3);
            dom.appendChild(el1, el2);
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var element1 = dom.childAt(fragment, [0]);
            var morph0 = dom.createMorphAt(dom.childAt(element1, [0]),0,0);
            var morph1 = dom.createMorphAt(dom.childAt(element1, [1]),0,0);
            inline(env, morph0, context, "t", ["promos.edit.bonuses.issue_code.label"], {});
            block(env, morph1, context, "sm-select", [], {"selectedOption": get(env, context, "promo.bonus_issue_promo"), "labelPath": ".name"}, child0, null);
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-subheader");
          var el2 = dom.createElement("h1");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("h2");
          var el3 = dom.createComment("");
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","plain-form-section");
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control order-sum");
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","inputs");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("span");
          var el5 = dom.createTextNode("   ");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("div");
          dom.setAttribute(el4,"class","caption");
          var el5 = dom.createComment("");
          dom.appendChild(el4, el5);
          dom.appendChild(el3, el4);
          var el4 = dom.createElement("br");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          var el2 = dom.createElement("div");
          dom.setAttribute(el2,"class","form-group-horizontal");
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","control-label");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          var el3 = dom.createElement("div");
          dom.setAttribute(el3,"class","form-control once-only");
          var el4 = dom.createComment("");
          dom.appendChild(el3, el4);
          dom.appendChild(el2, el3);
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var element2 = dom.childAt(fragment, [0]);
          var element3 = dom.childAt(fragment, [1]);
          var element4 = dom.childAt(element3, [0]);
          var element5 = dom.childAt(element3, [1]);
          var element6 = dom.childAt(element5, [1]);
          var element7 = dom.childAt(element3, [2]);
          var element8 = dom.childAt(element3, [3]);
          var element9 = dom.childAt(element3, [4]);
          var element10 = dom.childAt(element3, [5]);
          var element11 = dom.childAt(element10, [1]);
          var element12 = dom.childAt(element3, [6]);
          var element13 = dom.childAt(element3, [7]);
          var element14 = dom.childAt(element3, [9]);
          var morph0 = dom.createMorphAt(dom.childAt(element2, [0]),0,0);
          var morph1 = dom.createMorphAt(dom.childAt(element2, [1]),0,0);
          var morph2 = dom.createMorphAt(dom.childAt(element4, [0]),0,0);
          var morph3 = dom.createMorphAt(dom.childAt(element4, [1]),0,0);
          var morph4 = dom.createMorphAt(dom.childAt(element5, [0]),0,0);
          var morph5 = dom.createMorphAt(dom.childAt(element6, [0]),0,0);
          var morph6 = dom.createMorphAt(dom.childAt(element6, [1]),0,0);
          var morph7 = dom.createMorphAt(dom.childAt(element7, [0]),0,0);
          var morph8 = dom.createMorphAt(dom.childAt(element7, [1]),0,0);
          var morph9 = dom.createMorphAt(dom.childAt(element8, [0]),0,0);
          var morph10 = dom.createMorphAt(dom.childAt(element8, [1]),0,0);
          var morph11 = dom.createMorphAt(dom.childAt(element9, [0]),0,0);
          var morph12 = dom.createMorphAt(dom.childAt(element9, [1]),0,0);
          var morph13 = dom.createMorphAt(dom.childAt(element10, [0]),0,0);
          var morph14 = dom.createMorphAt(element11,0,0);
          var morph15 = dom.createMorphAt(dom.childAt(element11, [2]),0,0);
          var morph16 = dom.createMorphAt(element11,4,4);
          var morph17 = dom.createMorphAt(element11,5,5);
          var morph18 = dom.createMorphAt(dom.childAt(element12, [0]),0,0);
          var morph19 = dom.createMorphAt(dom.childAt(element12, [1]),0,0);
          var morph20 = dom.createMorphAt(dom.childAt(element13, [0]),0,0);
          var morph21 = dom.createMorphAt(dom.childAt(element13, [1]),0,0);
          var morph22 = dom.createMorphAt(element3,8,8);
          var morph23 = dom.createMorphAt(dom.childAt(element14, [0]),0,0);
          var morph24 = dom.createMorphAt(dom.childAt(element14, [1]),0,0);
          inline(env, morph0, context, "t", ["promos.edit.bonuses.header"], {});
          inline(env, morph1, context, "t", ["promos.edit.bonuses.comment"], {});
          inline(env, morph2, context, "t", ["promos.edit.bonuses.bonus_dishes.label"], {});
          block(env, morph3, context, "sm-chosen", [], {"classNames": "dishes-chosen", "content": get(env, context, "promo.bonus_dishes"), "labelPath": "name", "onQuery": "queryDishes", "onLoadMore": "loadMoreDishes", "insertEnabled": false}, child0, null);
          inline(env, morph4, context, "t", ["promos.edit.bonuses.bonus_price.label"], {});
          inline(env, morph5, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.bonus_price")});
          inline(env, morph6, context, "t", ["promos.edit.bonuses.bonus_price.caption"], {});
          inline(env, morph7, context, "t", ["promos.edit.bonuses.bonus_free_dishes.label"], {});
          block(env, morph8, context, "sm-chosen", [], {"classNames": "dishes-chosen", "content": get(env, context, "promo.bonus_free_dishes"), "labelPath": "name", "onQuery": "queryDishes", "onLoadMore": "loadMoreDishes", "insertEnabled": false}, child1, null);
          inline(env, morph9, context, "t", ["promos.edit.bonuses.discount_percent.label"], {});
          inline(env, morph10, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.discountPercent")});
          inline(env, morph11, context, "t", ["promos.edit.bonuses.discount_fixed.label"], {});
          inline(env, morph12, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.bonusSummandPositive")});
          inline(env, morph13, context, "t", ["promos.edit.bonuses.discount_dishes_percent.label"], {});
          inline(env, morph14, context, "sm-text-field", [], {"type": "number", "classNames": "numeric-field", "value": get(env, context, "promo.discountDishesPercent")});
          inline(env, morph15, context, "t", ["promos.edit.bonuses.discount_dishes_percent.caption"], {});
          block(env, morph16, context, "sm-checkbox", [], {"checked": get(env, context, "promo.dishes_price_multiplier_single_dish")}, child2, null);
          block(env, morph17, context, "if", [get(env, context, "promo.dishes_price_multiplier_single_dish")], {}, child3, null);
          inline(env, morph18, context, "t", ["promos.edit.bonuses.assign_tag.label"], {});
          block(env, morph19, context, "sm-chosen", [], {"content": get(env, context, "bonusTagCollection"), "labelPath": "name", "onQuery": "queryTags", "onAddItem": "assignBonusTag", "onRemoveItem": "removeBonusTag", "insertEnabled": false, "singular": true}, child4, null);
          inline(env, morph20, context, "t", ["promos.edit.bonuses.reset_tag.label"], {});
          block(env, morph21, context, "sm-chosen", [], {"content": get(env, context, "promo.client_bonus_reset_tags"), "labelPath": "name", "onQuery": "queryTags", "searchEnabled": false, "insertEnabled": false}, child5, null);
          block(env, morph22, context, "if", [get(env, context, "promo.organization.features.promos_issue_enabled")], {}, child6, null);
          inline(env, morph23, context, "t", ["promos.edit.free_delivery"], {});
          inline(env, morph24, context, "sm-toggle", [], {"checked": get(env, context, "promo.free_delivery")});
          return fragment;
        }
      };
    }());
    var child4 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          inline(env, morph0, context, "sm-button", [], {"classNames": "delete-button", "type": "gray", "textTranslation": "promos.edit.buttons.delete", "action": "deletePromo"});
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","main-content");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","plain-form edit-promo");
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","plain-form-header");
        var el4 = dom.createElement("button");
        dom.setAttribute(el4,"class","go-back");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        var el4 = dom.createElement("h1");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        var el4 = dom.createElement("h2");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        var el4 = dom.createElement("p");
        var el5 = dom.createTextNode(" ");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","plain-form-section");
        var el4 = dom.createElement("div");
        dom.setAttribute(el4,"class","button-block");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, element = hooks.element, inline = hooks.inline, get = hooks.get, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element115 = dom.childAt(fragment, [0, 0]);
        var element116 = dom.childAt(element115, [0]);
        var element117 = dom.childAt(element116, [0]);
        var element118 = dom.childAt(element115, [4, 0]);
        var morph0 = dom.createMorphAt(element117,0,0);
        var morph1 = dom.createMorphAt(dom.childAt(element116, [1]),0,0);
        var morph2 = dom.createMorphAt(dom.childAt(element116, [2]),0,0);
        var morph3 = dom.createMorphAt(element116,4,4);
        var morph4 = dom.createMorphAt(element115,1,1);
        var morph5 = dom.createMorphAt(element115,2,2);
        var morph6 = dom.createMorphAt(element115,3,3);
        var morph7 = dom.createMorphAt(element118,0,0);
        var morph8 = dom.createMorphAt(element118,1,1);
        var morph9 = dom.createMorphAt(element118,2,2);
        element(env, element117, context, "action", ["cancel"], {"on": "click"});
        inline(env, morph0, context, "t", ["promos.edit.back_button"], {});
        inline(env, morph1, context, "t", ["promos.edit.header"], {});
        inline(env, morph2, context, "t", ["promos.edit.subheader"], {});
        block(env, morph3, context, "sm-segmented", [], {"value": get(env, context, "currentTab")}, child0, null);
        block(env, morph4, context, "if", [get(env, context, "isMainPage")], {}, child1, null);
        block(env, morph5, context, "if", [get(env, context, "isConditionsPage")], {}, child2, null);
        block(env, morph6, context, "if", [get(env, context, "isBonusesPage")], {}, child3, null);
        inline(env, morph7, context, "sm-button", [], {"textTranslation": "promos.edit.buttons.save", "isLoading": get(env, context, "isLoading"), "action": "savePromo"});
        inline(env, morph8, context, "sm-button", [], {"textTranslation": "promos.edit.buttons.cancel", "type": "gray", "action": "cancel"});
        block(env, morph9, context, "unless", [get(env, context, "promo.isNew")], {}, child4, null);
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","scrollable-content");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","zero-data");
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","header");
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","caption");
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element0 = dom.childAt(fragment, [0, 0]);
        var morph0 = dom.createMorphAt(dom.childAt(element0, [0]),0,0);
        var morph1 = dom.createMorphAt(dom.childAt(element0, [1]),0,0);
        inline(env, morph0, context, "t", ["promos.not_in_tariff"], {});
        inline(env, morph1, context, "t", ["promos.not_in_tariff_caption"], {});
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createComment("");
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, get = hooks.get, block = hooks.block;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
      dom.insertBoundary(fragment, null);
      dom.insertBoundary(fragment, 0);
      block(env, morph0, context, "if", [get(env, context, "promosEnabled")], {}, child0, child1);
      return fragment;
    }
  };
}()));